import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../../environments/environment';
import { ProductRecipe } from '../../models/item/product-recipe';

@Injectable({
  providedIn: 'root',
})
export class ProductRecipeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/product-recipe';

  public getByNumbers(numbers: string[]): Observable<ApiResponse<ProductRecipe[]>> {
    return this.httpClient.post<ApiResponse<ProductRecipe[]>>(`${this.baseUrl}/number/batch`, numbers);
  }
}
